module.exports = __webpack_public_path__ + "media/images/page/top/top_img_06-6cb9d75e1b8d542bce0c063d75c112cd.png";